module.exports = __webpack_public_path__ + "static/media/logo.7939f7ae.png";